export const CALL_TO_ACTION = "CALL_TO_ACTION";
export const ABORT_CONFIGURATION = "ABORT_CONFIGURATION";
